import { ProductRow } from '../types';
import { thumbnailTransformer } from './thumbnailTransformer.ts';

export const transformers = {
  reviewCount: (value: number | string | null): number => {
    if (!value) return 0;
    if (typeof value === 'number') return value;

    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
  },

  reviewScore: (value: number | string | null): number => {
    if (!value) return 0;
    if (typeof value === 'number') return value;

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  },

  getLocalizedNames: (
    data: Pick<ProductRow, 'name_intl' | 'base_product_name_intl'>,
  ): {
    kr: string;
    en?: string;
    jp?: string;
  } => {
    const nameKr: string = data.name_intl?.kr || data.base_product_name_intl?.kr || 'Untitled Product';
    const nameEn = (data.name_intl?.en || data.base_product_name_intl?.en) ?? undefined;
    const nameJp = (data.name_intl?.jp || data.base_product_name_intl?.jp) ?? undefined;

    return {
      kr: nameKr,
      en: nameEn,
      jp: nameJp,
    };
  },

  thumbnail: thumbnailTransformer.transform,
};
